import { render, staticRenderFns } from "./SprintReviews.vue?vue&type=template&id=3975add1&scoped=true&"
import script from "./SprintReviews.vue?vue&type=script&lang=js&"
export * from "./SprintReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975add1",
  null
  
)

export default component.exports